import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance with auth interceptor
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('QQCRM-accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const aiSettingsService = {
  // Get all AI providers
  getProviders: async () => {
    try {
      const response = await api.get('/ai-settings/providers');
      return response.data;
    } catch (error) {
      console.error('Error fetching providers:', error);
      throw error.response?.data || error;
    }
  },

  // Get models for a specific provider
  getModels: async (provider) => {
    try {
      const response = await api.get(`/ai-settings/providers/${provider}/models`);
      return response.data;
    } catch (error) {
      console.error('Error fetching models:', error);
      throw error.response?.data || error;
    }
  },

  // Get AI settings for tenant
  getAiSettings: async (tenantId) => {
    try {
      const response = await api.get(`/ai-settings/tenant/${tenantId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching AI settings:', error);
      throw error.response?.data || error;
    }
  },

  // Update provider and model settings
  updateProviderSettings: async (tenantId, data) => {
    try {
      const response = await api.patch(
        `/ai-settings/tenant/${tenantId}/provider`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error updating provider settings:', error);
      throw error.response?.data || error;
    }
  },

  // Send a tiny ping to the configured AI provider to validate the key.
  testProvider: async (tenantId) => {
    const response = await api.post(`/ai-settings/tenant/${tenantId}/test`);
    return response.data;
  },

  // Create campaign
  createCampaign: async (tenantId, campaignData) => {
    try {
      const response = await api.post(
        `/ai-settings/tenant/${tenantId}/campaigns`,
        campaignData
      );
      return response.data;
    } catch (error) {
      console.error('Error creating campaign:', error);
      throw error.response?.data || error;
    }
  },

  // Update campaign
  updateCampaign: async (tenantId, campaignId, campaignData) => {
    try {
      const response = await api.patch(
        `/ai-settings/tenant/${tenantId}/campaigns/${campaignId}`,
        campaignData
      );
      return response.data;
    } catch (error) {
      console.error('Error updating campaign:', error);
      throw error.response?.data || error;
    }
  },

  // Delete campaign
  deleteCampaign: async (tenantId, campaignId) => {
    try {
      const response = await api.delete(
        `/ai-settings/tenant/${tenantId}/campaigns/${campaignId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting campaign:', error);
      throw error.response?.data || error;
    }
  },

  // Set campaign as active
  setActiveCampaign: async (tenantId, campaignId) => {
    try {
      const response = await api.patch(
        `/ai-settings/tenant/${tenantId}/campaigns/${campaignId}/set-active`
      );
      return response.data;
    } catch (error) {
      console.error('Error setting active campaign:', error);
      throw error.response?.data || error;
    }
  }
};

export default aiSettingsService;
